import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { crisisReferrals } from "./services/soar";
import { CardBody } from "react-bootstrap";
import moment from "moment";
import FieldDisplay from "./common/FieldDisplay";

function CrisisReferralsEntity({ clientId }) {
  const [referrals, setReferrals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getReferrals = async () => {
      const resp = await crisisReferrals({
        command: "query",
        application:
          process.env.REACT_APP_ENVIRONMENT === "Production"
            ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
            : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
        keyword: "byclient",
        ids: [clientId.replace(/[{}]/g, "")],
      });

      if (resp.code === "success") {
        setReferrals(resp.data);
      }
    };

    getReferrals();
  }, [clientId]);

  return (
    <div>
      <div className="col-11 h5 border-bottom">Crisis Referrals</div>
      {referrals?.map((referral, index) => (
        <Card className="mb-2" key={`cref${index}`}>
          <Card.Header
            className="p-0 ps-2 bg-safy1-1"
            style={{ color: "white" }}
          >
            <div className="row">
              <div className="col-10 ps-4 pt-1">
                {moment(referral.referralDateTime).format("L LT")}
              </div>
              <div className="col-2">
                <i
                  className="fas fa-pen float-end p-2"
                  onClick={() => navigate(`/crisis/${referral.id}`)}
                ></i>
              </div>
            </div>
          </Card.Header>
          <CardBody className="p-2 card-body-safy">
            {referral.referralSource ? (
              <FieldDisplay label="Source:" value={referral.referralSource} />
            ) : null}
            <FieldDisplay label="Status:" value={referral.status} />
          </CardBody>
        </Card>
      ))}
    </div>
  );
}

export default CrisisReferralsEntity;
